<template>
    <div class="quiz">
        <side-bar v-if="sufficient_width" :questions="questions" :answers="answers" />

        <div class="quiz__body">
            <h1 class="quiz__title">Find Your Perfect Gift</h1>

            <div v-if="post">
                <p class="quiz__question">{{ post.question }}</p>

                <ul class="quiz__options-wrapper" :class="which_questions">
                    <li v-for="(response, i) in post.responses" @click="choose(response)" class="quiz__option" :class="response.text | quiz_option_slug(chosen(response))" :key="i">
                        <img v-show="viewing_categories" class="quiz__option-img" :src="categoryImg(response.text)" >
                        <span class="quiz__option-text" v-show="!viewing_lifestyles">{{ response.text | option_text | uppercase }}</span>
                        <span class="life-style-option" v-show="viewing_lifestyles" :class="{ active: chosen(response) }">{{ response.text }}</span>
                    </li>
                </ul>
            </div>

            <quiz-navigation />
        </div>
    </div>
</template>

<script>
import Sidebar from './sidebar.vue'
import QuizLogic from '../data/quiz.json'
import QuizNavigation from './quiz-navigation.vue'

import { bus, contentAssetPath } from '../utilities'

export default {
    components: {
        'side-bar': Sidebar,
        'quiz-navigation': QuizNavigation,
    },
    filters: {
        slug(value) {
            return value ? value.replace(/\s/g, '_').toLowerCase() : ''
        },
    },
    data() {
        return {
            post: null,
            answer: null,
            path: window.path,
            showSaved: false,
            answers: [],
            questions: [
                'Who is it for?',
                'What category?',
                'How much are you looking to spend?',
                'What is the recipient\'s lifestyle?',
            ],
            page_width: document.body.clientWidth,
        }
    },
    computed: {
        answered() {
            return Object.keys(this.$route.params).length
        },
        which_questions() {
            return 'quiz__options-wrapper_'.concat(this.$route.name)
        },
        viewing_intro() {
            return this.$route.name === 'who'
        },
        viewing_categories() {
            return this.$route.name === 'category'
        },
        viewing_lifestyles() {
            return this.$route.name === 'lifestyle'
        },
        sufficient_width() {
            return this.page_width > 860
        },
    },
    watch: {
        $route: 'fetchData',
        answer() {
            bus.$emit('answer::chosen', this.answer)
        },
    },
    created() {
        this.fetchData()
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.page_width = document.body.clientWidth
        })
    },
    methods: {
        fetchData() {
            this.post = this.currentQuestion(this.$route.params)

            this.refreshAnswers()
        },
        getChoices(obj) {
            return Object.keys(obj).map((name) => ({ text: name }))
        },
        chosen(response) {
            return this.answer === response
        },
        refreshAnswers() {
            this.answers = []

            const path = this.cleanArray(this.$route.path.split('/'))
            const steps = path.splice(1, this.$route.path.length - 1)

            if (steps.length > 0) {
                steps.forEach((answer) => this.answers.push(answer))
            }
            this.answer = null
        },
        redirectHome() {
            this.$emit('next', { path: '/giftguide/' })
        },
        validResponses(params = {}) {
            const { lifestyle, price, category, who } = params

            if (who       && !QuizLogic[who]) return this.redirectHome()
            if (category  && !QuizLogic[who][category]) return this.redirectHome()
            if (price     && !QuizLogic[who][category][price]) return this.redirectHome()
            if (lifestyle && !QuizLogic[who][category][price][lifestyle]) return this.redirectHome()

            return true
        },
        currentQuestion(params) {
            const { lifestyle, price, category, who } = params

            if (!this.validResponses(params)) return

            const [question_0, question_1, question_2, question_3, question_4] = this.questions
            if (lifestyle) return { question: question_4, responses: this.getChoices(QuizLogic[who][category][price][lifestyle]) }
            if (price)     return { question: question_3, responses: this.getChoices(QuizLogic[who][category][price]) }
            if (category)  return { question: question_2, responses: this.getChoices(QuizLogic[who][category]) }
            if (who)       return { question: question_1, responses: this.getChoices(QuizLogic[who]) }

            return { question: question_0, responses: this.getChoices(QuizLogic) }
        },
        choose(choice) {
            const temp = [...this.answers]
            temp[this.answered] = choice.text
            this.answers = temp

            this.answer = choice
        },
        categoryImg(category) {
            switch (category) {
                case 'Mens':
                    return contentAssetPath('img/quiz_options__mens.png')
                case 'Sun Care':
                    return contentAssetPath('img/quiz_options__suncare.png')
                case 'Skincare':
                    return contentAssetPath('img/quiz_options__skincare.png')
                case 'Makeup':
                    return contentAssetPath('img/quiz_options__makeup.png')
                default:
                    return ''
            }
        },
        cleanArray: (array) => array.filter((i) => i),
    },
}
</script>


// WEBPACK FOOTER //
// src/js/app/components/quiz.vue